import styled from "@emotion/styled";

export const Message = styled.div({
    fontSize: "16px",
});

export const LoadingNote = styled.div({
    height: 120,
    marginTop: 30,
    width: 460,
});

export const ViewNoteObjectTag = styled.object({
    width: 860,
    height: "calc(100vh - 197px)",
    marginBottom: -30,
});

export const PreviewNoteError = styled.div({
    width: 480,
});

export const MessageBoxErrorLog = styled.div(props => ({
    padding: "15px 20px",
    marginTop: 30,
    marginBottom: 10,
    backgroundColor: props.theme.candy.semanticColors.warning.backgroundColor,
}));

export const Footer = styled.footer({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
});
